import {
  CUSTOMERS_REQUEST, CUSTOMERS_SUCCESS,
  CUSTOMERS_STATUS_REQUEST, CUSTOMERS_STATUS_SUCCESS
} from '../constants/actionTypes';
import {getApiConfig} from '../utilities';

const getCustomersMethods = getApiConfig('Users/GetCustomers');
const changeCustomerStatusMethods = getApiConfig('Users/EnableCustomer');

export const ActionTypes = {
  GET_ENABLED_ENTITIES_REQUEST: 'global/get-enabled-entities-request',
  GET_ENABLED_ENTITIES_RESPONSE: 'global/get-enabled-entities-response',
  SELECT_ENABLED_ENTITY: 'global/select-enabled-entity',
  APP_SET_AS_CUSTOMER: 'global/app-set-as-customer'
}

export const getCustomers = (page = 0, pageSize = 50, searchKeyword = '') => {
  return dispatch => {
    dispatch({
      type: CUSTOMERS_REQUEST,
      searchKeyword
    });
    const data = {
      page,
      pageSize
    };
    if (searchKeyword) {
      data.FilterBy = {
        filter: searchKeyword
      }
    }
    getCustomersMethods.post(data)
      .then(data => {
        dispatch({
          type: CUSTOMERS_SUCCESS,
          data
        })
      })
  }
}

export const changeCustomerStatus = (customerId, enabled) => {
  return dispatch => {
    dispatch({type: CUSTOMERS_STATUS_REQUEST});

    changeCustomerStatusMethods.post({customerId, enabled})
      .then(() => {
        dispatch({
          type: CUSTOMERS_STATUS_SUCCESS,
          success: true
        })
      })
  }
}

let abortablePromise = null;

export const getEnabledEntities = (page = 0, term = '') => {
  return (dispatch, getState) => {
    const state = getState();
    const {auth} = state;

    if (abortablePromise) {
      abortablePromise.abort();
      abortablePromise = null;
    }

    dispatch({
      type: ActionTypes.GET_ENABLED_ENTITIES_REQUEST,
      payload: {page, term}
    });

    abortablePromise = getApiConfig('Users/AllEnabledEntities');

    return abortablePromise
      .post({
        filterBy: {
          term
        },
        page
      })
      .then(data => {
        dispatch({
          type: ActionTypes.GET_ENABLED_ENTITIES_RESPONSE,
          payload: data
        });
      })
      .catch(err => {
        if (err.name === 'AbortError') {
          // console.log('Request was aborted');
        } else {
          console.error('Fetch error:', err);
        }
      });
  }
}

export const selectEnabledEntity = (entity) => {
  return {
    type: ActionTypes.SELECT_ENABLED_ENTITY,
    payload: entity
  }
}


export const appSetAsCustomer = (set) => {
  return {
    type: ActionTypes.APP_SET_AS_CUSTOMER,
    payload: {set}
  }
}

